import axios from 'axios'

export default {
  getAll: async sitePath => {
    const url = `${sitePath}/site/`
    const response = await axios.get(url)

    return response.data
  },

  delete: async (sitePath, id) => {
    const url = `${sitePath}/site/${id}/`
    const response = await axios.delete(url)

    return response.data
  },

  get: async (sitePath, id) => {
    const url = `${sitePath}/site/${id}/`
    const response = await axios.get(url)

    return response.data
  },

  post: async (sitePath, data) => {
    const url = `${sitePath}/site/`
    const response = await axios.post(url, data)

    return response.data
  },

  put: async (sitePath, id, data) => {
    const url = `${sitePath}/site/${id}/`
    const response = await axios.put(url, data)

    return response.data
  },

  postSite: async (sitePath, formData) => {
    const url = `${sitePath}/site/`
    let response = await axios.post(
      url,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response.data
  },

  putSite: async (sitePath, id, formData) => {
    const url = `${sitePath}/site/${id}/`
    let response = await axios.put(
      url,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response.data
  },
}
